import { router } from "@inertiajs/react"
import { market_switch_path } from "@/lib/routes"

// A deliberate market switch (slug null = All markets): the server saves it
// for the Menu's market links, then opens `to`.
export function switchMarket(slug: string | null, to: string) {
  router.post(market_switch_path(), { market: slug, to })
}
